import type { AddressFields, ContactFields } from "@utils/BasicTypes";
import { validateSideTab, validateTab } from "@utils/general";
import {
	sanitize,
	validateAddress,
	validateBookingPaymentMethod,
	validateContact,
} from "@utils/validation";
import { debounceStorage } from "../../../..";
import { state, ui } from "../../../../interfaces/interfaces";

const FORM_VALIDATION_DELAY = 150;

export const bookingMiddleware = async (
	action: { payload: { name: string; value: any } },
	next: any,
) => {
	switch (action.payload.name) {
		case "BookingPaymentMethodCompanyRegistration":
			validateBookingPaymentMethod(
				"BookingPaymentMethod",
				"CompanyRegistration",
				action.payload.value,
			);
			validateTab("BookingPayment");
			state.BookingPaymentMethodCompanyRegistrationAccepted = false;
			return next(action);

		case "BookingPaymentMethodCardAgreed":
			validateBookingPaymentMethod(
				"BookingPaymentMethod",
				"CardAgreed",
				action.payload.value,
			);
			return next(action);

		case "BookingPaymentMethodCardSecured":
			validateBookingPaymentMethod(
				"BookingPaymentMethod",
				"CardSecured",
				action.payload.value,
			);
			if (action.payload.value) {
				state.JobWasCardReceived = true;
				validateTab("BookingPayment");
			}

			return next(action);

		//BookingPaymentPaymentMethodsValid
		case "BookingPaymentMethodPaymentMethodsValid":
			// setConfirmationBillingDetailsPaymentMethodPaymentMethodValid(action.payload.value);
			// validate("BookingPayment", "CardAgreed", action.payload.value);
			return next(action);

		case "BookingPaymentMethodPaymentRequisitions":
			validateBookingPaymentMethod(
				"BookingPaymentMethod",
				"PaymentRequisitions",
				action.payload.value?.name ? action.payload.value.name : "",
			);
			validateTab("BookingPayment");
			return next(action);

		case "BookingPaymentAddressAsProperty":
			if (action.payload.value) {
				ui.BookingPaymentAddressProperty = ui.PropertyAddressProperty;
				ui.BookingPaymentAddressProperty = ui.PropertyAddressProperty;
				ui.BookingPaymentAddressStreet = ui.PropertyAddressStreet;
				ui.BookingPaymentAddressLocality = ui.PropertyAddressLocality;
				ui.BookingPaymentAddressCity = ui.PropertyAddressCity;
				ui.BookingPaymentAddressPostcode = ui.PropertyAddressPostcode;
				ui.BookingPaymentAddressIsBusiness = ui.PropertyAddressIsBusiness;
			} else {
				ui.BookingPaymentAddressProperty = "";
				ui.BookingPaymentAddressProperty = "";
				ui.BookingPaymentAddressStreet = "";
				ui.BookingPaymentAddressLocality = "";
				ui.BookingPaymentAddressCity = "";
				ui.BookingPaymentAddressPostcode = "";
				ui.BookingPaymentAddressIsBusiness = false;
			}
			{
				const validateInputAndForm = () => {
					validateSideTab("BookingPaymentAddress");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			}
			return next(action);

		case "BookingPaymentContactAsContact":
			if (action.payload.value) {
				ui.BookingPaymentContactEmail = ui.PropertyContactEmail;
				ui.BookingPaymentContactFirstName = ui.PropertyContactFirstName;
				ui.BookingPaymentContactLastName = ui.PropertyContactLastName;
				ui.BookingPaymentContactLandline = ui.PropertyContactLandline;
				ui.BookingPaymentContactMobile = ui.PropertyContactMobile;
				ui.BookingPaymentContactTitle = ui.PropertyContactTitle;
			} else {
				ui.BookingPaymentContactEmail = "";
				ui.BookingPaymentContactFirstName = "";
				ui.BookingPaymentContactLastName = "";
				ui.BookingPaymentContactLandline = "";
				ui.BookingPaymentContactMobile = "";
				ui.BookingPaymentContactTitle = "";
			}
			{
				const validateInputAndForm = () => {
					validateSideTab("BookingPaymentContact");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			}
			return next(action);

		case "BookingPaymentMethodPaymentMethods":
			ui.BookingPaymentMethodCardAgreed = false;
			validateBookingPaymentMethod(
				"BookingPaymentMethod",
				"PaymentMethods",
				action.payload.value,
			);
			state.JobPaymentMethodId = action.payload.value?.id;
			if (action.payload.value?.id === 4)
				state.BookingPaymentMethodIsRequisition = true;
			else state.BookingPaymentMethodIsRequisition = false;
			return next(action);

		case "BookingPaymentIsBooked":
			ui.BookingRejectionReason = null;
			return next(action);

		case "BookingPaymentAddressProperty":
		case "BookingPaymentAddressStreet":
		case "BookingPaymentAddressLocality":
		case "BookingPaymentAddressPostcode":
		case "BookingPaymentAddressCity":
		case "BookingPaymentAddressCounty":
		case "BookingPaymentAddressBusinessName":
		case "BookingPaymentContactFirstName":
		case "BookingPaymentContactLastName":
		case "BookingPaymentContactTitle":
		case "BookingPaymentContactMobile":
		case "BookingPaymentContactLandline":
		case "BookingPaymentContactEmail": {
			const stage = "BookingPayment";
			const step = action.payload.name.includes("Address")
				? "Address"
				: "Contact";
			const property = action.payload.name.replace(stage + step, "");

			action.payload.value = sanitize(action.payload.value, property);
			switch (property) {
				case "Title":
				case "FirstName":
				case "LastName":
				case "Mobile":
				case "Landline":
				case "Email": {
					const validateInputAndForm = () => {
						validateContact(
							"BookingPaymentContact",
							property as ContactFields,
							action.payload.value,
						);
						validateSideTab("BookingPaymentContact");
					};
					debounceStorage.addOrExecute({
						name: action.payload.name,
						delay: FORM_VALIDATION_DELAY,
						callback: validateInputAndForm,
					});
					break;
				}

				case "BusinessName":
				case "Property":
				case "Street":
				case "Locality":
				case "City":
				case "Postcode": {
					const validateInputAndForm = () => {
						validateAddress(
							"BookingPaymentAddress",
							property as AddressFields,
							action.payload.value,
						);
						validateSideTab("BookingPaymentAddress");
					};
					debounceStorage.addOrExecute({
						name: action.payload.name,
						delay: FORM_VALIDATION_DELAY,
						callback: validateInputAndForm,
					});
					break;
				}

				default:
					break;
			}
			return next(action);
		}
	}
};
